import React from 'react';

import styles from './Signal.module.scss';

import type { ISignalProps } from './Signal.type';

export const Signal: React.FC<ISignalProps> = ({ countEl, title, testId }) => {
    return (
        <li
            className={styles['signal-display__container']}
            data-testid={testId}
        >
            <div className="eds-text-bl eds-text-weight--heavy">{countEl}</div>
            <p
                className={`${styles.infoText} eds-text-weight--regular eds-text-color--ui-600`}
            >
                {title}
            </p>
        </li>
    );
};
